import { createNavigation } from 'next-intl/navigation';

import { routing } from './routing';

// Lightweight wrappers around Next.js' navigation APIs
// that handle the locale automatically
export const { Link, redirect, usePathname, useRouter, getPathname } = createNavigation(routing);
